/**

jQuery.syg_pagescroll
version 3.0
Hiroshi Fukuda <dada@sygnas.jp>
http://sygnas.jp/

The MIT License

Copyright (c) 2011-2012 Hiroshi Fukuda, http://sygnas.jp/

= example 1 =

    <a href="#hogehoge">hogehoge</a>

    <div id="hogehoge">
    </div>

    <script src="lib/jquery.syg_pagescroll.1.0.js"></script>
    <script>
        new $.SygPageScroll( 'a' );
    </script>


= example 2 =

    <a href="#hogehoge" class="scroll">hogehoge</a>

    <div id="hogehoge">
    </div>

    <script src="lib/jquery.easing.1.3.js"></script>
    <script src="lib/jquery.syg_pagescroll.1.0.js"></script>
    <script>
        new $.SygPageScroll( 'a.scroll', {time:2000, easing:'easeInOutCubic'} );
    </script>

*****************************************/

/** ***************************************

2017.03.15 ver.3.0
    ・ES2015形式に変更
2016.11.23 ver.2.1
    ・$(target).click(); を $(document).on('click',target,function(){}); に変更
2016.06.8 ver 2
    ・Webpack用に作り直し
2015.04.26 ver 1.3
    ・スクロール先IDが無い場合は普通にリンクさせる
2013.03.08 ver 1.1
    ・位置補正オプション「plus」を追加。

*****************************************/

export default class CaracolPageScroll {

    /**
     * コンストラクタ
     * @param {string} target ターゲットエレメント
     * @param {object} config
     */
    constructor(target, config) {

        const defaults = {
            easing: 'swing',
            time: 1000,
            plus: 0
        };

        this.opt = Object.assign(defaults, config);

        /**
         * クリックしたら目的の位置へスクロール
         */
        $(document).on('click', target, (e) => {
            // リンクタグからハッシュ（ターゲットID）を取得
            const hash = e.currentTarget.hash;

            if ($(hash).length) {
                const y = $(hash).offset().top + this.opt.plus;
                $('html,body').animate({ scrollTop: y },
                    this.opt.time, this.opt.easing);
                return false;
            }
            return true;
        });
    }
}




// WEBPACK FOOTER //
// /Users/dada/www/_caracol_works/javascript/for_webpack/caracol/caracol_es2015.1.0/effect/pagescroll.js